import React, { useState, useEffect } from "react";
import { getFirestore, endBefore, collection,doc, updateDoc, addDoc, query, getDocs, limit, startAfter, orderBy, where } from "firebase/firestore";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.js";
import StaffManagement from "./StaffManagement.js";
import "./Puestos.css";

const Puestos = () => {
  const db = getFirestore();
  const { currentUser } = useAuth();
  const [vacantes, setVacantes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showPostulantes, setShowPostulantes] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastVisible, setLastVisible] = useState(null);
  const [isLastPage, setIsLastPage] = useState(false);
  const [postulantes, setPostulantes] = useState([]);
  const [selectedVacanteId, setSelectedVacanteId] = useState(null);
  const [postulantesLastVisible, setPostulantesLastVisible] = useState(null);
  const [postulantesFirstVisible, setPostulantesFirstVisible] = useState(null);
  const [currentPostulantesPage, setCurrentPostulantesPage] = useState(1);
  const [postulantesIsLastPage, setPostulantesIsLastPage] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  

  const navigate = useNavigate();

  const ITEMS_PER_PAGE = 10;

  useEffect(() => {
    fetchVacantes();
  }, []);

  const fetchVacantes = async (direction = "next") => {
    const collectionRef = collection(db, "vacantes");
    const userUID = currentUser?.uid; // UID del usuario autenticado
  
    let q;
  
    if (direction === "next" && lastVisible) {
      q = query(
        collectionRef,
        where("uid", "==", userUID), // Filtrar por el UID del usuario
        orderBy("createdAt", "desc"),
        startAfter(lastVisible),
        limit(ITEMS_PER_PAGE)
      );
    } else {
      q = query(
        collectionRef,
        where("uid", "==", userUID), // Filtrar por el UID del usuario
        orderBy("createdAt", "desc"),
        limit(ITEMS_PER_PAGE)
      );
    }
  
    try {
      const snapshot = await getDocs(q);
  
      const fetchedVacantes = await Promise.all(
        snapshot.docs.map(async (doc) => {
          const vacante = { id: doc.id, ...doc.data() };
          const postulantesCount = await fetchPostulantesCount(doc.id);
          return { ...vacante, solicitudesCount: postulantesCount };
        })
      );
  
      setLastVisible(snapshot.docs[snapshot.docs.length - 1] || null);
      setIsLastPage(snapshot.size < ITEMS_PER_PAGE);
      setVacantes(fetchedVacantes);
    } catch (error) {
      console.error("Error al obtener vacantes: ", error);
    }
  };
  

  const fetchPostulantesCount = async (vacanteId) => {
    if (!vacanteId) return 0;
    const postulantesRef = collection(db, "postulaciones");
    const q = query(postulantesRef, where("vacanteId", "==", vacanteId));
    const snapshot = await getDocs(q);
    return snapshot.size;
  };

  const fetchPostulantes = async (direction) => {
    if (!selectedVacanteId) return;
    const postulantesRef = collection(db, "postulaciones");
    let q;

    if (direction === "next" && postulantesLastVisible) {
      q = query(
        postulantesRef,
        where("vacanteId", "==", selectedVacanteId),
        startAfter(postulantesLastVisible),
        limit(ITEMS_PER_PAGE)
      );
    } else if (direction === "prev" && postulantesFirstVisible) {
      q = query(
        postulantesRef,
        where("vacanteId", "==", selectedVacanteId),
        endBefore(postulantesFirstVisible),
        limit(ITEMS_PER_PAGE)
      );
    } else {
      return;
    }

    const snapshot = await getDocs(q);

    const fetchedPostulantes = await Promise.all(
      snapshot.docs.map(async (doc) => {
        const data = doc.data();
        const userSnapshot = await getDocs(
          query(collection(db, "users"), where("uid", "==", data.uid))
        );
        const user = userSnapshot.docs[0]?.data();

        return {
          id: doc.id,
          ...data,
          nombre: user?.nombre || "Desconocido",
        };
      })
    );

    setPostulantes(fetchedPostulantes);
    setPostulantesLastVisible(snapshot.docs[snapshot.docs.length - 1] || null);
    setPostulantesFirstVisible(snapshot.docs[0] || null);
    setCurrentPostulantesPage((prev) =>
      direction === "next" ? prev + 1 : prev - 1
    );
    setPostulantesIsLastPage(snapshot.size < ITEMS_PER_PAGE);
  };



  const handleViewPostulantes = async (vacanteId) => {
    if (!vacanteId) {
      console.error("vacanteId es undefined o inválido");
      return;
    }
  
    try {
      const postulantesRef = collection(db, "postulaciones");
      const q = query(
        postulantesRef,
        where("vacanteId", "==", vacanteId),
        limit(ITEMS_PER_PAGE)
      );
  
      const snapshot = await getDocs(q);
  
      const fetchedPostulantes = snapshot.docs.map((doc) => {
        const data = doc.data();
      
        return {
          id: doc.id,
          ...data,
          nombre: data.nombre || "Nombre no especificado", // Tomar el nombre directamente de la colección postulantes
        };
      });
      
      
  
      setPostulantes(fetchedPostulantes);
      setSelectedVacanteId(vacanteId);
      setShowPostulantes(true);
      setPostulantesLastVisible(snapshot.docs[snapshot.docs.length - 1] || null);
      setPostulantesFirstVisible(snapshot.docs[0] || null);
      setCurrentPostulantesPage(1);
      setPostulantesIsLastPage(snapshot.size < ITEMS_PER_PAGE);
    } catch (error) {
      console.error("Error al obtener postulantes:", error);
    }
  };
  

  // Función para manejar el envío del formulario (guardar vacante)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const fechaCierreInput = e.target.fechaCierre.value; // Valor en formato "YYYY-MM-DD"
    const fechaCierre = new Date(`${fechaCierreInput}T00:00:00`);

    const nuevoPuesto = {
      titulo: e.target.titulo.value,
      descripcion: e.target.descripcion.value,
      ubicacion: e.target.ubicacion.value,
      salario: e.target.salario.value,
      moneda: e.target.moneda.value,
      tipoContrato: e.target.tipoContrato.value,
      nivelExperiencia: e.target.nivelExperiencia.value,
      habilidades: e.target.habilidades.value,
      fechaCierre,
      beneficios: e.target.beneficios.value,
      createdAt: new Date(),
      uid: currentUser.uid,
      estado: "iniciada",
    };

    try {
      await addDoc(collection(db, "vacantes"), nuevoPuesto);
      fetchVacantes();
      setShowModal(false);
    } catch (error) {
      console.error("Error al guardar vacante: ", error);
    }
  };

  const handleVerCV = (userId) => {
    if (!userId) {
      console.error("El uid es undefined o inválido");
      return;
    }
    navigate(`/curriculum/${userId}`);
  };

  //Funcion para cambiar estado de vacante
  const handleFinalizarVacante = async (vacanteId) => {
    try {
      const vacanteRef = doc(db, "vacantes", vacanteId);
      await updateDoc(vacanteRef, { estado: "finalizó" });
      // Actualizar el estado local para reflejar el cambio
      setVacantes((prev) =>
        prev.map((vacante) =>
          vacante.id === vacanteId
            ? { ...vacante, estado: "finalizó" }
            : vacante
        )
      );
      setShowPopup(false);
    } catch (error) {
      console.error("Error al finalizar vacante: ", error);
    }
  };
  

  // Función para cerrar el modal de creación de vacante
  const closeModal = () => {
    setShowModal(false);
  };

  // Función para cerrar el modal de postulantes
  const closePostulantesModal = () => {
    setShowPostulantes(false);
  };

  const handleOpenPopup = (vacanteId) => {
    setSelectedVacanteId(vacanteId);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setSelectedVacanteId(null);
    setShowPopup(false);
  };
  
  

  return (
    <div className="puestos">
      <h2>Gestión de Puestos</h2>
      <button className="btn btn-primary" onClick={() => setShowModal(true)}>
        Crear nueva vacante
      </button>

      <table className="table">
        <thead>
          <tr>
            <th>Puesto</th>
            <th>Solicitudes</th>
            <th>Estado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {vacantes.map((vacante) => (
            <tr key={vacante.id}>
              <td>{vacante.titulo}</td>
              <td>
                <button
                  className="btn-link"
                  onClick={() => handleViewPostulantes(vacante.id)}
                >
                  {vacante.solicitudesCount || 0}
                </button>
              </td>
              <td> {vacante.estado}</td>
              <td><i className="fa fa-ellipsis-v icon-action"
                      style={{ cursor: "pointer", marginLeft: "10px" }}
                      onClick={() => handleOpenPopup(vacante.id)} ></i>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pop-up para finalizar vacante */}
      {showPopup && (
        <div className="popup-container">
          <div className="popup-content">
            <h3>¿Finalizar esta vacante?</h3>
            <p>Esto cambiará el estado de la vacante a "Finalizado".</p>
            <div className="popup-actions">
              <button
                className="btn btn-danger"
                onClick={() => handleFinalizarVacante(selectedVacanteId)}
              >
                Finalizar
              </button>
              <button
                className="btn btn-secondary"
                onClick={handleClosePopup}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="pagination">
        {currentPage > 1 && (
          <button
            className="btn btn-secondary"
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            Atrás
          </button>
        )}
        {!isLastPage && (
          <button
            className="btn btn-secondary"
            onClick={() => fetchVacantes("next")}
          >
            Siguiente
          </button>
        )}
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>Crear Nuevo Puesto</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="titulo">Título del Puesto</label>
                <input type="text" id="titulo" name="titulo" className="form-control" required />
              </div>
              <div className="form-group">
                <label htmlFor="descripcion">Descripción</label>
                <textarea id="descripcion" name="descripcion" className="form-control" required></textarea>
              </div>
              <div className="form-group">
                <label htmlFor="ubicacion">Ubicación</label>
                <input type="text" id="ubicacion" name="ubicacion" className="form-control" required />
              </div>
              <div className="form-group">
                <label htmlFor="salario">Salario</label>
                <input type="number" id="salario" name="salario" className="form-control" required />
              </div>
              <div className="form-group">
                <label htmlFor="moneda">Moneda</label>
                <select id="moneda" name="moneda" className="form-control" required>
                  <option value="usd">Dólares estadounidences</option>
                  <option value="ars">Pesos argentinos</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="tipoContrato">Tipo de Contrato</label>
                <select id="tipoContrato" name="tipoContrato" className="form-control" required>
                  <option value="Full-Time">Full-Time</option>
                  <option value="Part-Time">Part-Time</option>
                  <option value="Freelance">Freelance</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="nivelExperiencia">Nivel de Experiencia</label>
                <select id="nivelExperiencia" name="nivelExperiencia" className="form-control" required>
                  <option value="Junior">Junior</option>
                  <option value="Mid">Mid</option>
                  <option value="Senior">Senior</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="habilidades">Habilidades Requeridas</label>
                <textarea id="habilidades" name="habilidades" className="form-control" required></textarea>
              </div>
              <div className="form-group">
                <label htmlFor="fechaCierre">Fecha de Cierre</label>
                <input type="date" id="fechaCierre" name="fechaCierre" className="form-control" required />
              </div>
              <div className="form-group">
                <label htmlFor="beneficios">Beneficios</label>
                <textarea id="beneficios" name="beneficios" className="form-control" required></textarea>
              </div>
              <button type="submit" className="btn btn-primary">
                Crear Vacante
              </button>
              <button type="button" className="btn btn-secondary" onClick={closeModal}>
                Cancelar
              </button>
            </form>
          </div>
        </div>
      )}

      {showPostulantes && (
        <div className="modal">
          <div className="modal-content-postulante">
            <h3>Postulantes</h3>
            <button className="btn btn-secondary" onClick={closePostulantesModal}>
              Cerrar
            </button>
            <table className="table table-postulante">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Ver CV</th>
                  <th>Fecha de Postulación</th>
                </tr>
              </thead>
              <tbody>
                {postulantes.map((postulante) => (
                  <tr key={postulante.id}>
                    <td>{postulante.nombre}</td>
                    <td> <button onClick={() => handleVerCV(postulante.userId)} className="buton-postulante">
                      Ver CV
                    </button>
                    </td>
                    <td>{postulante.createdAt.toDate().toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="pagination">
              {currentPostulantesPage > 1 && (
                <button
                  className="btn btn-secondary"
                  onClick={() => fetchPostulantes("prev")}
                >
                  Atrás
                </button>
              )}
              {!postulantesIsLastPage && (
                <button
                  className="btn btn-secondary"
                  onClick={() => fetchPostulantes("next")}
                >
                  Siguiente
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      <StaffManagement />
    </div>
  );
};

export default Puestos;
